import React from "react";
import AppLoader from "../Design/AppLoader";

/**
 * The application's lazy/Suspense fallback.
 *
 * This is the single fallback behind all 106 route definitions in
 * Drawer/Routes.tsx, so it is the one place the branded loading experience had
 * to land to reach every route at once. It used to render a bare MUI
 * CircularProgress; it now renders the GT Brokers loader.
 *
 * The signature is unchanged — `height` still controls the reserved space, and
 * every existing call site keeps working untouched. Nothing about when loading
 * starts or stops has changed: this component only decides what a wait looks
 * like.
 */
const Loader = ({ height, label }: { height?: string; label?: string }) => (
  <AppLoader
    variant="page"
    height={height ?? "100vh"}
    label={label ?? "Loading..."}
  />
);

Loader.defaultProps = {
  height: "100vh",
};

export default Loader;
